import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getAllEntityAppointments } from '../api'
import { ENTITY_TYPES } from '@sales-center/common'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'
import { guestRoleName } from '@user/components/Settings/Users/UpdateUser/constants'
import { externalAppTimeoutError } from '@user/store/utilities/functions'

type Status = 'pending' | 'success' | 'fail'

export function useGetEntityAppointmentsOnMount(
  entityId: number,
  entityType: ENTITY_TYPES,
) {
  const dispatch = useAppDispatch()
  const currentUser = useSelector(selectCurrentUser)
  const isGuestUser = currentUser?.roleName === guestRoleName

  const [status, setStatus] = useState<Status>('pending')

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (!isGuestUser) {
        try {
          const result = await dispatch(
            getAllEntityAppointments({
              entityId,
              entityType,
            }),
          )

          if (mounted) {
            if (getAllEntityAppointments.fulfilled.match(result)) {
              setStatus('success')
            } else {
              externalAppTimeoutError(result.payload)
              setStatus('fail')
            }
          }
        } catch {
          if (mounted) setStatus('fail')
        }
      } else {
        setStatus('success')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, entityId, entityType, isGuestUser])

  return status
}
